import script from "./UserTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./UserTitle.vue?vue&type=script&setup=true&lang=js"

import "./UserTitle.vue?vue&type=style&index=0&id=2a3610d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a3610d4"]])

export default __exports__